export enum InstructionType {
  List = 'list',
  Numeric = 'numeric',
}
